/* eslint-disable */
import React from 'react';
import Typical from 'react-typical';
import { SubHeading } from '../../components';
import { images } from '../../constants';
import './Header.css';
import Aos from "aos";
import "aos/dist/aos.css";

const Header = () => {

  React.useEffect(() => {
    Aos.init();
  }, []);

  return (

  
  <div className="app__header app__wrapper section__padding" id="home">
    <div className="app__wrapper_info"  data-aos="fade-up"
  data-aos-easing="ease-out-cubic"
  data-aos-duration="2000">
      <SubHeading title="Fast Food Au Mans" />
      <h1 className="app__header-h1">Bienvenue à Volcano Oasis</h1>
      <Typical
                loop={Infinity}
                wrapper="b"
                className="p__opensans" style={{ margin: '2rem 0' }}
                steps={[
                  'Large choix de produits français 💯🌋',
                  2500,
                  'Nos Tacos Contiennent Une Sauce Fromagère Faite Maison 💯🌯',
                  2500,
                  'La Pate Des Pizza est Faite Maison Le Jour Meme 💯🍕',
                  2500,
                  'Excellent rapport qualité-prix 💯😊',
                  2500,
                  'Savoir-faire dans le domaine et Acceuil Chaleureux 💯💡'
                ]}
              />
      <p className="p__opensans" style={{ margin: '2rem 0' }}>Après un bon succès du premier fast food Volcano à l'université, 
       Nous avons ouvert le deuxième Fast Food dans le sud du mans. </p>
      <button type="button" className="custom__button"><a href="#menu"> Voir Menu</a></button>
    </div>

    <div className="app__wrapper_img ">
      <img className='header__img' src={images.volcano} alt="header_img" />
    </div>
  </div>

)};

export default Header;
